import script from "./ManagerBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerBase.vue?vue&type=script&setup=true&lang=js"

import "./ManagerBase.vue?vue&type=style&index=0&id=d0a5b6f0&lang=scss"

const __exports__ = script;

export default __exports__